import { useState } from "react";
import { createEntityStore } from "../../common/entityStore";
import { propNumberField } from "../../common/entityStoreForm";
import { IconButton } from "@mui/material";
import { AddCircle } from "@mui/icons-material";
import { propInt, propMinValue, propValidValue, propValueValidator } from "../../common/entityStoreValidators";
import { useDefaultValues } from "../../common/defaultValues";
import { formatNumber, getResource, getValidationText } from "../../common/localization";
import { SaleArticleDto } from "../../common/order";
import { useRxJsSub } from "../../common/utils";
import { distinctUntilChanged, map } from "rxjs";

function getText(key: string, defaultMessage?: string) {
    return getResource("Ui.Order.Articles." + key, defaultMessage) as string;
}

export function ArticleAdd({
    article,
    articleQuantities,
    addArticle,
}: {
    article: SaleArticleDto;
    articleQuantities: { [saleArticleId: string]: number | null; };
    addArticle(article: SaleArticleDto, quantity: number): void;
}) {
    const [useColumnStore] = useState(() => createEntityStore<ArticleAddData>({
        data: {
            quantity: article.baseQuantity,
        },
        id: null,
        propValidators: [
            propValidValue("quantity", "quantityFormatted"),
            propInt("quantity"),
            propMinValue("quantity", 1),
            propValueValidator("quantity", p => p != null && p / article.baseQuantity % 1 !== 0 &&
                getValidationText("QuantityMustBeMultiple")
                    .replaceAll("{0}", formatNumber(article.baseQuantity, useDefaultValues.getState().clientData.landCode, false))),
        ],
        isValidationEnabled: true,
    }));
    useRxJsSub(() => useColumnStore.getState().clientData$.pipe(map(p => p.data.quantity), distinctUntilChanged()).subscribe(p => {
        articleQuantities[article.id!] = useColumnStore.getState().isSaveDisabled ? null : p;
    }));
    async function save() {
        if (useColumnStore.getState().isSaveDisabled) {
            return;
        }
        const quantity = useColumnStore.getState().clientData.quantity ?? article.baseQuantity;
        addArticle(article, quantity);
    }
    return <div style={{ display: "flex" }} onClick={p => { p.stopPropagation(); }}>
        <IconButton sx={{ ml: -2 }} onClick={save} title={getText("Add")}><AddCircle /></IconButton>
        {propNumberField(useColumnStore)("quantity", "quantityFormatted", "", { showTooltipError: true, sx: { "& input": { padding: "3px 6px" } } })}
    </div>;
}

interface ArticleAddData {
    quantity: number | null;
    quantityFormatted?: string;
}
